<template>
  <div class="account">
    <drag-modal :visible="visible" @cancel="cancel" :title="(edit==1?'编辑':'新增')+'用户组'" width="500px">
      <a-form-model-item label="用户组名称：" prop="title">
        <a-input v-model="form.title" placeholder="请设置用户组名称" :maxLength="8" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="是否是内部用户组" prop="is_inner">
        <a-switch checked-children="是" un-checked-children="否" default-checked v-model='form.is_inner' />
      </a-form-model-item>
      <a-form-model-item style="text-align: center" :wrapper-col="{ span: 24 }">
          <a-button type="primary" @click="onSubmit()">提交</a-button>
      </a-form-model-item>
    </drag-modal>
    <div class="top wbg">
      <a-row :gutter="24" type="flex">
        <a-col :span="6" class="col">
          <a-button type="primary" ghost icon="plus" @click="edit=2;visible=true">新增</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="tcon wbg">
      <div class="tableList">
        <table class="table" style="table-layout: fixed;">
          <thead class="thead">
            <td width='10%'>序号</td>
            <td width='70%'>用户组名称</td>
            <td width="10%">是否是内部用户组</td>  
            <td width="10%">操作</td>
          </thead>
          <tbody>
            <tr v-for='(i,index) in list' :key='i.id'>
              <td>{{index+1 }}</td>
              <td>{{i.title}}</td>
              <td>{{ i.is_inner==1?'是':'否' }}</td>
              <td>
                <a href="javascript:void(0);" @click="editForm(i)">编辑</a>
                <span class="line"></span>
                <a-popconfirm title="确认删除吗?" ok-text="确定" cancel-text="取消" @confirm="del(i.id)">
                  <a href="javascript:void(0);" style="color:#f00;">删除</a>
                </a-popconfirm>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="pages" v-if="count>10">
          <a-pagination v-model="form.page" show-quick-jumper :total="count" show-less-items :pageSize='10' @change='turnpage' />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { userGrounp } from '@/server/user'
export default {
  data() {
    return {
      list: [],
      count: 0,
      visible:false,
      edit:0, //0 查看  1编辑 2新增
      form: {
        title:'',
        is_inner:false,
        id:''
      },
    }
  },
  created() {
    this.query()
  },
  methods: {
    onSubmit(){
      const form=JSON.parse(JSON.stringify(this.form))
      form.is_inner=form.is_inner?1:0
      if(this.edit==2) delete form.id
      userGrounp(this.edit==1?'edit':'add',form).then((res) => {
        this.$message.success(this.edit==1?'编辑成功':'新增成功')
        this.list = res.list;
        this.count = res.count
        this.cancel()
        this.query()
      })
    },
    editForm(item){
      this.form.title=item.title;
      this.form.is_inner=item.is_inner==1?true:false
      this.form.id=item.id
      this.edit=1;
      this.visible=true;
    },
    del(id){
      userGrounp('delete',{id:id}).then((res) => {
        this.$message.success('删除成功')
        this.query()
      })
    },
    cancel(){
      this.form.title=''
      this.form.is_inner=false;
      this.visible=false;
    },
    query() {
      userGrounp('index').then((res) => {
        this.list = res.list;
        this.count = res.count
      })
    }
  }
}
</script>
<style lang="less" scoped>
.col {
  display: flex;
  align-items: center;
  label {
    white-space: nowrap;
  }
}
.account {
  .top {
    padding: 20px;
    .group {
      display: flex;
      align-items: center;
    }
    .to {
      display: inline-block;
      width: 20px;
      height: 1px;
      margin: 0 10px;
      background-color: #dbdcde;
      vertical-align: middle;
    }
    form {
      width: 100%;
    }
    .label {
      display: inline-block;
      margin-right: 60px;
      font-size: 14px;
      color: #0e2949;
    }
    .btns {
      float: right;
      button {
        margin-left: 20px;
        min-width: 90px;
      }
    }
  }
}
.ant-btn {
  border-color: #1d8bfe;
  color: #1d8bfe;
}
// .ant-btn-primary {
//   color: #ffffff;
//   border-color: #1d8bfe;
//   background-color: #1d8bfe;
// }
.tcon {
  padding: 0 20px;
  min-height: 760px;
  .tableList {
    width: 100%;
    .table {
      thead {
        td {
          padding-left: 0;
          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }
      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }
        td {
          .del{
            margin-left:20px;
          }
          padding: 6px 0;
          height: 60px;
          &:nth-child(1) {
            padding-left: 20px;
          }
          p,
          .p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;
            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}
.modal-footer {
  text-align: center;
  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
.pages {
  text-align: right;
}
</style>
